import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogContent } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-busy-dialog',
  template: `
    <mat-dialog-content>
      <mat-progress-spinner mode="indeterminate" [diameter]="48" />
    </mat-dialog-content>
  `,
  imports: [MatDialogContent, MatProgressSpinnerModule, MatButtonModule],
})
export class BusyDialogComponent {
  private readonly dialogService = inject(MatDialog);
}
